import React from 'react';
import {
  ADOBE_PLUGINS,
  AdobePluginSteps,
  AdobePluginType
} from '@pages/AdminSettings/components/IntegrationTab/InstallInstructions/adobe-plugin';
import type { InstalledIntegrationDetailsProps } from '@pages/AdminSettings/components/IntegrationTab/constants';
import {
  SetupHelp,
  SetupLayout
} from '@pages/AdminSettings/components/IntegrationTab/setup-layout';

/** An installed Adobe plugin: how people get it, again. */
export default function AdobePluginInstalledDetails({
  integration
}: InstalledIntegrationDetailsProps) {
  const pluginType = integration.type as AdobePluginType;
  const { productName, logo } = ADOBE_PLUGINS[pluginType];
  return (
    <SetupLayout
      logo={logo}
      title={`StreamWork plugin for ${productName}`}
      subtitle="Installed for this organization: it works here for everyone. Share the plugin with your team."
    >
      <AdobePluginSteps pluginType={pluginType} />
      <SetupHelp subject="the plugin" />
    </SetupLayout>
  );
}
